import { useAuth } from '../lib/auth-context';

export function TenantSwitcher() {
  const { allTenants, activeTenantId, switchTenant } = useAuth();

  if (allTenants.length === 0) return null;

  const activeTenant = allTenants.find(t => t.id === activeTenantId);

  return (
    <div>
      {allTenants.length > 1 ? (
        <>
          <label className="text-xs text-gray-500 uppercase tracking-wide mb-2 block">Organization</label>
          <select
            value={activeTenantId}
            onChange={(e) => switchTenant(e.target.value)}
            className="w-full bg-sg-card text-white text-sm border border-sg-border rounded-lg px-3 py-2.5 focus:outline-none focus:border-sg-accent hover:bg-sg-dark transition-colors"
          >
            {allTenants.map((t) => (
              <option key={t.id} value={t.id}>
                {t.label}
              </option>
            ))}
          </select>
          {activeTenant && (
            <p className="text-xs text-gray-500 mt-1.5">{activeTenant.domain}</p>
          )}
        </>
      ) : (
        activeTenant && (
          <div className="px-3 py-2.5 bg-sg-card rounded-lg">
            <p className="text-xs text-gray-500 mb-0.5">Organization</p>
            <p className="text-sm text-white font-medium">{activeTenant.label}</p>
            <p className="text-xs text-gray-400 mt-0.5">{activeTenant.domain}</p>
          </div>
        )
      )}
    </div>
  );
}
